import moment from 'moment';

// Oldest year offered in the request year filters
export const FIRST_YEAR = 2022;

// Current year down to FIRST_YEAR
export const yearOptions = () => {
    const years = [];
    for (let y = moment().year(); y >= FIRST_YEAR; y--) years.push(y);
    return years;
};

// Jan 1 – Dec 31 of the given year, as YYYY-MM-DD strings
export const yearRange = (year) => ({ from: `${year}-01-01`, to: `${year}-12-31` });
